import { defineCustomClientStrategy, isLocale } from "@estate-platform/i18n/runtime";

import type { Locale } from "@estate-platform/i18n/runtime";

const storageKey = "estate-platform:language";

const read = (): string | null => {
  try {
    return localStorage.getItem(storageKey);
  } catch {
    return null;
  }
};

export const storedDeviceLanguage = (): string | undefined => read() ?? undefined;

const pickedKey = "estate-platform:language-picked";

export const rememberPickedLanguage = (language: Locale): void => {
  try {
    localStorage.setItem(pickedKey, language);
  } catch {
    // WHY: without storage the account's language simply wins after sign-in.
  }
};

// WHY: a footer choice counts for the next sign-in only (the link may open in another tab), then it is spent.
const spendPicked = (): string | null => {
  try {
    const picked = localStorage.getItem(pickedKey);
    localStorage.removeItem(pickedKey);
    return picked;
  } catch {
    return null;
  }
};

export const takePickedLanguage = (): Locale | null => {
  const picked = spendPicked();
  return picked !== null && isLocale(picked) ? picked : null;
};

// WHY: before any choice the browser decides: any French tag (fr-CH, fr-BE, fr-FR) gives French, anything else English.
const browserLanguage = (): string | undefined =>
  navigator.languages.some((tag) => tag.split("-", 1)[0] === "fr") ? "fr" : undefined;

// WHY: read once per page load, so every message of a page speaks one language even when another tab switches.
export const rememberDeviceLanguage = (): void => {
  let current = storedDeviceLanguage() ?? browserLanguage();
  defineCustomClientStrategy("custom-device", {
    getLocale: () => current,
    setLocale: (locale) => {
      current = locale;
      try {
        localStorage.setItem(storageKey, locale);
      } catch {
        // WHY: blocked storage keeps the browser's language; switchLanguage then skips the reload.
      }
    },
  });
};
